'use strict';
//pikaday
import Pikaday from 'pikaday';
import "pikaday/css/pikaday.css";
//moment
import moment from 'moment';
moment.locale('lt');
//tooltipster
import Tooltipster from 'tooltipster';
import "tooltipster/dist/css/tooltipster.bundle.css";
//vanilla text mask
import maskInput from 'vanilla-text-mask';

import {EwSiteApp} from '../app/ewsiteapp';

EwSiteApp.controller('CommentsCtrl', ['$scope', '$http', '$attrs', '$log', function ($scope, $http, $attrs, $log) {
		$scope.postUrl = '';
		$scope.getUrl = '';
		$scope.hash_key = '';
		$scope.isconfirm = false;
		$scope.errors = [];
		$scope.comments = {
			list: []
		};
		$scope.all_displayed = false;

		$scope.clearCommentsForm = function () {
			$scope.comment.name = "";
			$scope.comment.email = "";
			$scope.comment.comment = "";
			$scope.errors = [];
			$scope.commentform.$setPristine();
		};

//jsonp -comentaru listui

		$scope.submit = function () {
			if ($scope.postUrl !== '') {
				$scope.isconfirm = false;
				$http({
					method: 'POST',
					url: $scope.postUrl + '?hash_key=' + $scope.hash_key,
					data: $scope.comment,
					xsrfCookieName: $scope.hash_key
				}).then(function (response) {
					if (response.data.data.success) {
						$scope.clearCommentsForm();
						$scope.isconfirm = response.data.data.isconfirm;
						if (!$scope.isconfirm) {
							$scope.getList(1);
						}
					} else if (angular.isDefined(response.data.data.messages)) {
//					$log.debug(data.data.message);
						$scope.errors = response.data.data.messages;
					}
					if (angular.isDefined(response.data.data.debug)) {
						$log.debug(response.data.data.debug);
					}
					if (!$scope.isconfirm) {
						$('html, body').animate({
							scrollTop: $(".comments_list").offset().top - 10
						}, 300);
					}
				}, function (response) {
					console.log(['Error', response]);
				});
			}
		};

		$scope.getList = function (getall) {
			if (getall == 1) {
				$scope.all_displayed = true;
			}
			if ($scope.getUrl !== '') {
				$http({
					method: 'GET',
					url: $scope.getUrl + '?getall=' + getall + ';hash_key=' + $scope.hash_key,
				}).then(function (response) {
					$scope.comments.list = response.data.list;
					if (getall == 0 && response.data.totalRows <= $scope.limit) {
						$scope.all_displayed = true;
					}
				}, function (response) {
					console.log(['Error', response]);
				});
			}
		};

		$scope.hasErrors = function () {
			return $scope.errors.length > 0;
		};




	}]).directive('commentsContainer', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.postUrl = '';
			scope.getUrl = '';
			scope.hash_key = '';
			scope.limit = 10;
			if (attr.postUrl !== '') {
				scope.postUrl = attr.postUrl;
			}
			if (attr.id !== '') {
				scope.hash_key = attr.id;
			}
			if (attr.limit !== '') {
				scope.limit = attr.limit;
			}
			if (attr.getUrl !== '') {
				scope.getUrl = attr.getUrl;
				scope.getList(0);
			}

		}
	};
});
EwSiteApp.controller('SuggestSearchCtrl', ['$scope', '$log', 'ajaxSearch', '$timeout', '$sce', '$filter', function ($scope, $log, ajaxSearch, $timeout, $sce, $filter) {
		$scope.searchUrl = '';
		$scope.sdquery = '';
		$scope.searchresults = [];
		$scope.total = 0;
		$scope.search_url = '';
		$scope.inputTouched = false;
		$scope.templates = {
			title_description: 'search/title_description.html',
			img_title: 'search/img_title.html',
			img_title_description: 'search/img_title_description.html',
			module_gallery: 'search/module_gallery.html',
			module_youtubegallery: 'search/module_youtubegallery.html',
		};
		$scope.str_len = 400;

		// Move the highlightFilter function outside of the controller
		function highlightFilter(text, search) {
			if (!search) {
				return $sce.trustAsHtml(text);
			}
			return $sce.trustAsHtml(text.replace(new RegExp(search, 'gi'), '<span class="highlight">$&</span>'));
		}

		// Expose the function to the $scope
		$scope.highlightFilter = highlightFilter;

		$scope.find = function () {
			if ($scope.searchUrl !== '') {
				$timeout(function () {
					$scope.inputTouched = true;
				}, 500);
				ajaxSearch.search($scope.searchUrl, {sdquery: $scope.sdquery}).then(function (results) {
					if ($scope.sdquery === '') {
						$scope.clear();
					} else {
						$scope.displaySearchResults(results);
						$scope.displaySuggestions(results);
						$scope.total = results.total;
						$scope.search_url = results.search_url;
					}
				}, function (response) {
					$log.error(response);
				});
			}
		};

		$scope.displaySearchResults = function (results) {
			$scope.searchresults = results.data;
		};

		$scope.displaySuggestions = function (results) {
			$scope.suggestions = results.suggestions;
		};

		$scope.clear = function () {
			$scope.sdquery = '';
			$scope.total = 0;
			$scope.displaySearchResults([]);
			$scope.displaySuggestions([]);
		};

		$scope.getDataTemplate = function (data) {
			if (data.module === 'gallery' || data.module === 'photoalbums') {
				data.display_options.template.id = 'module_gallery';
			}
			if (data.module === 'youtubegallery') {
				data.display_options.template.id = 'module_youtubegallery';
			}
			if (typeof (data.display_options.template.id) !== 'undefined' && typeof ($scope.templates[data.display_options.template.id]) !== 'undefined') {
				return $scope.templates[data.display_options.template.id];
			}
			return $scope.templates.title_description;
		};

		$scope.changeLocationHash = function (data, name, varname) {
			var hash = '!' + name + data.display_options.vars[varname];
			location.hash = hash;
		};

		// Custom date formatting filter for Lithuanian date format
		$scope.formatCustomDate = function (timestamp) {
			if (!timestamp)
				return '';

			// Convert timestamp to Date object
			const date = new Date(timestamp * 1000);

			// Extract year, day, and month
			const year = $filter('date')(date, 'yyyy');
			const day = $filter('date')(date, 'dd');

			// Define month names in Lithuanian
			const monthNames = [
				'sausio', 'vasario', 'kovo', 'balandžio', 'gegužės', 'birželio',
				'liepos', 'rugpjūčio', 'rugsėjo', 'spalio', 'lapkričio', 'gruodžio'
			];
			const month = monthNames[date.getMonth()];  // Get month name

			// Return formatted string in Lithuanian style
			return `${year} m. ${month} ${day} d.`;
		};
	}]).directive('suggestSearchContainer', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.searchUrl = '';
			if (attr.searchUrl !== '') {
				scope.searchUrl = attr.searchUrl;
			}
		}
	};
});

//Eucookie
EwSiteApp.controller('EuCookieCtrl', [
	'$scope', '$http', '$attrs', '$log', '$timeout',
	function ($scope, $http, $attrs, $log, $timeout) {
		$scope.data = {};
		$scope.state = 0;
		$scope.pop = false;
		$scope.showLine = true;
		$scope.message = '';
		$scope.loading = false;
		$scope.error = false;

		// --- helper inside this controller: make popup tables responsive ---
		var _mobileTablesUid = 0;
		function makeTablesResponsive(root) {
			var $root = root ? $(root) : $(".main-content");
			if (!$root.length)
				return;

			$root.find("table").each(function () {
				var $el = $(this);

				// Skip if already wrapped
				if ($el.parent().hasClass("scrollable"))
					return;

				// Create wrapper and move table inside
				var $wrap = $('<div class="scrollable"><div></div></div>');
				$wrap.insertBefore($el);
				$el.appendTo($wrap.find("div"));

				// Unique namespace per table so we don't pile up handlers
				var uid = $el.data("mtUid");
				if (!uid) {
					uid = ++_mobileTablesUid;
					$el.data("mtUid", uid);
				}
				var ns = ".mt_" + uid;

				function recompute() {
					if ($el.outerWidth() > $el.parent().outerWidth()) {
						$wrap.addClass("has-scroll");
					} else {
						$wrap.removeClass("has-scroll");
					}
				}

				// Initial compute
				recompute();

				// Bind/refresh listeners for this table
				$(window)
						.off("resize" + ns)
						.off("orientationchange" + ns)
						.on("resize" + ns, recompute)
						.on("orientationchange" + ns, recompute);
			});
		}
		// -------------------------------------------------------------------

		const dialog = document.getElementById('policyDialog');
		if (dialog) {
			var openBtn = document.getElementById('openPolicyDialog');
			var closeBtn = document.getElementById('closePolicyDialog');

			if (openBtn) {
				openBtn.onclick = () => {
					dialog.showModal();
					// After dialog is visible, enhance its tables
					requestAnimationFrame(() => makeTablesResponsive('#policyDialog'));
				};
			}
			if (closeBtn) {
				closeBtn.onclick = () => dialog.close();
			}

			// If opened programmatically elsewhere, still enhance tables
			dialog.addEventListener('toggle', () => {
				if (dialog.open) {
					requestAnimationFrame(() => makeTablesResponsive('#policyDialog'));
				}
			});
		}

		$scope.hiddeLine = function () {
			$scope.showLine = !$scope.showLine;
		};
		$scope.closePopup = function () {
			$scope.pop = false;
		};
		$scope.showPop = function () {
			$scope.pop = !$scope.pop;
			if ($scope.pop) {
				// Run after Angular updates DOM visibility
				$timeout(function () {
					makeTablesResponsive('#eucookie_dialog');
				}, 0);
			}
		};

		// Also catch external changes that set pop=true
		$scope.$watch('pop', function (val) {
			if (val) {
				$timeout(function () {
					makeTablesResponsive('#eucookie_dialog');
				}, 0);
			}
		});

		$scope.storeChoises = function () {
			$scope.loading = true;
			$http({
				method: 'POST',
				url: unescape($attrs.storeUrl),
				data: $scope.data,
				xsrfCookieName: secure_xsrf_name,
				xsrfHeaderName: 'X-' + secure_xsrf_name
			}).then(function (response) {
				if (typeof (response.data.message) !== 'undefined' && response.data.message) {
					$scope.message = response.data.message;
					$scope.loading = false;

					$scope.hiddeLine();
					var body = document.querySelector("body.cookies-not-activated");
					if (body)
						body.classList.remove("cookies-not-activated");
					var euDlg = document.querySelector("#eucookie_dialog");
					if (euDlg) {
						euDlg.classList.add("activated");
						$timeout(function () {
							makeTablesResponsive(euDlg);
						}, 0);
					}
				} else {
					$scope.error = true;
					$scope.loading = false;
				}
				if (typeof (response.data.reload) !== 'undefined' && response.data.reload) {
					reloadPage();
				}
				if (typeof (response.data.collection) !== 'undefined') {
					loadCollection(response.data.collection);
				}
			}, function (response) {
				$scope.hiddeLine();
				var body = document.querySelector("body.cookies-not-activated");
				if (body)
					body.classList.remove("cookies-not-activated");
				var euDlg = document.querySelector("#eucookie_dialog");
				if (euDlg) {
					euDlg.classList.add("activated");
					$timeout(function () {
						makeTablesResponsive(euDlg);
					}, 0);
				}
				console.log(['Error', response]);
			});
		};

		$scope.initPopUp = function () {
			$scope.showLine = true;
		};

		$scope.storeAllChoises = function () {
			$scope.data.privacy_2 = true;
			$scope.data.privacy_3 = true;
			$scope.data.privacy_4 = true;
			$scope.storeChoises();
		};

		$scope.toggleKeyHandler = function ($event, key) {
			if ($event.key === 'Enter' || $event.key === ' ' || $event.keyCode === 13 || $event.keyCode === 32) {
				$event.preventDefault(); // Prevent page from scrolling on spacebar
				$scope.data[key] = !$scope.data[key];
			}
		};

		function loadCollection(collection) {
			let ifr = document.createElement('iframe');
			ifr.style.display = 'none';
			document.body.appendChild(ifr);
			if (typeof (collection.head) !== 'undefined' && collection.head.length > 0) {
				for (let bl of collection.head) {
					ifr.contentDocument.head.innerHTML += bl;
				}
				for (let nod of ifr.contentDocument.head.childNodes) {
					if (nod.nodeType !== 1) {
						continue;
					}
					let ss = document.createElement(nod.tagName);
					for (let att of nod.attributes) {
						ss.setAttribute(att.nodeName, att.nodeValue);
					}
					ss.innerText = nod.innerText;
					document.head.appendChild(ss);
				}
			}
			document.body.removeChild(ifr);
		}

		function reloadPage() {
			location.reload();
		}
	}
]);


EwSiteApp.controller('MultiUpload', ['$scope', '$filter', '$log', '$timeout', function ($scope, $filter, $log, $timeout) {
		$scope.uploaded_files = [];
		$scope.files = [];
		$scope.files.errors = [];
		$scope.files.hasError = false;
		$scope.max_file_size = 0;
		$scope.uploadCount = 0;
		$scope.fieldId = 0;


		$scope.closeAlert = function (index) {
			$scope.files.errors.splice(index, 1);
//		$scope.errors.splice(index, 1);
		};

		$scope.transmitToParentTotalupl = function () {
			if (null !== $scope.uploaded_files) {
				let length = Object.values($scope.uploaded_files).length;
				if (!Number.isNaN(length)) {
					$scope.$parent.total_upl += length;
					$scope.uploadCount = length;
					if (length > 0) {
						$scope.$parent.changeState($scope.fieldId, true);
					}
				}
			}
		};

		$timeout(function () {
			$scope.transmitToParentTotalupl();
		}, 50);

		$scope.transmitToParent = function () {
			$scope.$parent.total_upl += 1;
			$scope.uploadCount += 1;
			$scope.$parent.changeState($scope.fieldId, true);
		};

		$scope.onFileAdded = function ($file, extensions) {
			if ($file.flowObj.opts.singleFile) {
				$scope.uploaded_files = [];
			}
			var output = false;
			if ($scope.max_file_size > 0 && $file.size > $scope.max_file_size) {
				$scope.files.hasError = true;
				$scope.files.errors.push($file.name + ' ' + $scope.too_large_error_msg);
				return output;
			}
			if (typeof (extensions[$file.getExtension()]) !== "undefined" && extensions[$file.getExtension()] == 1) {
				output = true;
			}
			$scope.$parent.changeState($scope.fieldId, false);
			if (!output) {
				$scope.files.hasError = true;
				$scope.files.errors.push($file.name + ' ' + $scope.error_msg);
			}
			return output;
		};

		function flowErrors($file) {
			if (typeof ($file.response) !== 'undefined') {
				if (typeof ($file.response.fileId) !== 'undefined' && $file.response.fileId > 0 && $file.response.success) {
					return true;
				} else if (typeof ($file.response.message) !== 'undefined') {
					$scope.files.hasError = true;
					$scope.files.errors.push($file.name + ' - ' + $file.response.message);
					return false;
				}
			} else {
				$scope.files.hasError = true;
				$scope.files.errors.push($file.name + ' - Server error');
				return false;
			}
			return null;
		}

		$scope.onFileSuccess = function ($file, $message, flowFile) {
			let flow_errors = flowErrors($file);
			if (true === flow_errors) {
				$scope.transmitToParent();
			} else if (false === flow_errors) {
				flowFile.cancel();
			}
		};

		$scope.onFileError = function ($file, $message, flowFile) {
			if (false === flowErrors($file)) {
				flowFile.cancel();
			}
		};

		$scope.removeufile = function (file_id) {
			delete $scope.uploaded_files[file_id];
			$scope.decreaseUplCount();
		};

		$scope.decreaseUplCount = function () {
			if ($scope.$parent.total_upl > 0) {
				$scope.$parent.total_upl -= 1;
			}
			if ($scope.uploadCount > 0) {
				$scope.uploadCount -= 1;
			}
			if ($scope.uploadCount == 0) {
				$scope.$parent.changeState($scope.fieldId, false);
			}
		};

		$scope.removeUploaded = function (file) {
			file.cancel();
			$scope.decreaseUplCount();
		};

	}]);

EwSiteApp.directive('numbersOnly', function () {
	return {
		restrict: 'A',
		scope: {
			value: '=ngModel'
		},
		controller: ['$scope', function ($scope) {
				$scope.$watch(function () {
					return $scope.value;
				}, function (newVal) {
					if (newVal !== undefined && newVal !== null) {
						$scope.value = String(newVal).replace(/[^0-9\+]/g, '');
					}
				});
			}]
	};
});

EwSiteApp.directive('floatNumbers', function () {
	return {
		restrict: 'A',
		scope: {
			value: '=ngModel'
		},
		controller: ['$scope', function ($scope) {
				$scope.$watch(function () {
					return $scope.value;
				}, function (newVal) {
					if (typeof newVal !== 'undefined') {
						$scope.value = newVal.replace(/,/, '.').replace(/[^0-9\.]/g, '');
					}
				});
			}]
	};
});

EwSiteApp.directive('popUpSelect', ['$timeout', function ($timeout) {
		return {
			restrict: 'A',
			scope: {
				ngModel: '='
			},
			link: function (scope, element, attr) {

				$(element).select2({
					"minimumResultsForSearch": -1
				});
				// $(element).select2();
				scope.$watch(function () {
					return scope.ngModel;
				}, function () {
					$timeout(function () {
						$(element).trigger('change');
					}, 20);
				});
			}
		};
	}]);

EwSiteApp.directive('popUpSelectForms', ['$timeout', function ($timeout) {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function (scope, element, attrs, ngModel) {
				$(element).select2({minimumResultsForSearch: -1});

				// MODEL -> VIEW
				ngModel.$render = function () {
					var val = ngModel.$viewValue == null ? '' : String(ngModel.$viewValue);
					$timeout(function () {
						$(element).val(val).trigger('change.select2'); // ensure Select2 UI reflects model
					});
				};

				// VIEW -> MODEL
				$(element).on('change', function () {
					scope.$applyAsync(function () {
						ngModel.$setViewValue($(element).val());
					});
				});

				// If options are populated asynchronously, refresh when they change
				if (attrs.ngOptions || attrs.ngRepeat) {
					scope.$watch(function () {
						return element[0].length;
					}, function () {
						ngModel.$render();
					});
				}

				// Kick initial sync
				$timeout(ngModel.$render);

				// Cleanup
				scope.$on('$destroy', function () {
					$(element).off('change').select2('destroy');
				});
			}
		};
	}]);


EwSiteApp.directive('tooltip', ['$timeout', function ($timeout) {
		return {
			restrict: 'A',
			link: function (scope, element, attr) {
				// Function to check if the device is mobile
				function isMobile() {
					return /Mobi|Android/i.test(navigator.userAgent);
				}

				// Configure Tooltipster based on device type
				$(element).tooltipster({
					delay: 15,
					contentAsHTML: true,
					maxWidth: 280,
					interactive: true,
					touchDevices: true,
					touchMaxPoints: 1,
					trigger: isMobile() ? 'click' : 'hover'
				});
			}
		};
	}]);

EwSiteApp.directive('datepicker1', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			new Pikaday({
				field: element[0], // Ensure the raw DOM element is passed
				firstDay: 1,
				format: 'YYYY-MM-DD',
				showDaysInNextAndPreviousMonths: true,
				toString(date) {
					return moment(date).format('YYYY-MM-DD');
				},
				parse(dateString) {
					return moment(dateString, 'YYYY-MM-DD').toDate();
				},
				i18n: {
					previousMonth: 'Ankstesnis mėnuo',
					nextMonth: 'Kitas mėnuo',
					months: moment.localeData().months(),
					weekdays: moment.localeData().weekdays(),
					weekdaysShort: moment.localeData().weekdaysShort()
				},
				yearRange: [1900, new Date().getFullYear()+3], // Show years from 1900 to the current year
				position: 'right'
			});
			element.addClass('datepicker'); // Use element directly without jQuery
		}
	};
});

EwSiteApp.directive('datepicker1fromtoday', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			new Pikaday({
				field: element[0],
				firstDay: 1,
				format: 'YYYY-MM-DD',
				showDaysInNextAndPreviousMonths: true,
				minDate: new Date(),
				toString(date) {
					return moment(date).format('YYYY-MM-DD');
				},
				parse(dateString) {
					return moment(dateString, 'YYYY-MM-DD').toDate();
				},
				i18n: {
					previousMonth: 'Ankstesnis mėnuo',
					nextMonth: 'Kitas mėnuo',
					months: moment.localeData().months(),
					weekdays: moment.localeData().weekdays(),
					weekdaysShort: moment.localeData().weekdaysShort()
				},
				yearRange: [1900, new Date().getFullYear()],
				position: 'right'
			});
			element.addClass('datepicker');
		}
	};
});

EwSiteApp.directive('datepicker1totoday', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			new Pikaday({
				field: element[0],
				firstDay: 1,
				format: 'YYYY-MM-DD',
				showDaysInNextAndPreviousMonths: true,
				maxDate: new Date(),
				toString(date) {
					return moment(date).format('YYYY-MM-DD');
				},
				parse(dateString) {
					return moment(dateString, 'YYYY-MM-DD').toDate();
				},
				i18n: {
					previousMonth: 'Ankstesnis mėnuo',
					nextMonth: 'Kitas mėnuo',
					months: moment.localeData().months(),
					weekdays: moment.localeData().weekdays(),
					weekdaysShort: moment.localeData().weekdaysShort()
				},
				yearRange: [1900, new Date().getFullYear()],
				position: 'right'
			});
			element.addClass('datepicker');
		}
	};
});

EwSiteApp.directive('datepicker1period', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			const dateFrom = moment(attr.dateFrom, 'YYYY-MM-DD').startOf('day');
			const dateTo = moment(attr.dateTo, 'YYYY-MM-DD').endOf('day');

			const picker = new Pikaday({
				field: element[0],
				firstDay: 1,
				format: 'YYYY-MM-DD',
				showDaysInNextAndPreviousMonths: true,
				toString(date) {
					return moment(date).format('YYYY-MM-DD');
				},
				parse(dateString) {
					return moment(dateString, 'YYYY-MM-DD').toDate();
				},
				minDate: dateFrom.toDate(),
				maxDate: dateTo.toDate(),
				disableDayFn: function (date) {
					// Disable any date outside the specified period
					return moment(date).isBefore(dateFrom) || moment(date).isAfter(dateTo);
				},
				i18n: {
					previousMonth: 'Ankstesnis mėnuo',
					nextMonth: 'Kitas mėnuo',
					months: moment.localeData().months(),
					weekdays: moment.localeData().weekdays(),
					weekdaysShort: moment.localeData().weekdaysShort()
				},
				yearRange: [1900, new Date().getFullYear()],
				position: 'right'
			});

			element.addClass('datepicker');
		}
	};
});

EwSiteApp.directive('datepicker1weekdays', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			const picker = new Pikaday({
				field: element[0],
				firstDay: 1,
				format: 'YYYY-MM-DD',
				showDaysInNextAndPreviousMonths: true,
				disableDayFn: function (date) {
					const day = date.getDay();
					return day === 0 || day === 6; // Disable Sunday (0) and Saturday (6)
				},
				toString(date) {
					return moment(date).format('YYYY-MM-DD');
				},
				parse(dateString) {
					return moment(dateString, 'YYYY-MM-DD').toDate();
				},
				i18n: {
					previousMonth: 'Ankstesnis mėnuo',
					nextMonth: 'Kitas mėnuo',
					months: moment.localeData().months(),
					weekdays: moment.localeData().weekdays(),
					weekdaysShort: moment.localeData().weekdaysShort()
				},
				yearRange: [1900, new Date().getFullYear()],
				position: 'right'
			});
			element.addClass('datepicker');
		}
	};
});

EwSiteApp.directive('datepicker1weekends', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			const picker = new Pikaday({
				field: element[0],
				firstDay: 1,
				format: 'YYYY-MM-DD',
				showDaysInNextAndPreviousMonths: true,
				disableDayFn: function (date) {
					const day = date.getDay();
					return day >= 1 && day <= 5; // Disable weekdays (Mon–Fri)
				},
				toString(date) {
					return moment(date).format('YYYY-MM-DD');
				},
				parse(dateString) {
					return moment(dateString, 'YYYY-MM-DD').toDate();
				},
				i18n: {
					previousMonth: 'Ankstesnis mėnuo',
					nextMonth: 'Kitas mėnuo',
					months: moment.localeData().months(),
					weekdays: moment.localeData().weekdays(),
					weekdaysShort: moment.localeData().weekdaysShort()
				},
				yearRange: [1900, new Date().getFullYear()],
				position: 'right'
			});
			element.addClass('datepicker');
		}
	};
});

EwSiteApp.directive('datepicker1periodonlyworkdays', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			const dateFrom = moment(attr.dateFrom, 'YYYY-MM-DD').startOf('day');
			const dateTo = moment(attr.dateTo, 'YYYY-MM-DD').endOf('day');

			const picker = new Pikaday({
				field: element[0],
				firstDay: 1,
				format: 'YYYY-MM-DD',
				showDaysInNextAndPreviousMonths: true,
				toString(date) {
					return moment(date).format('YYYY-MM-DD');
				},
				parse(dateString) {
					return moment(dateString, 'YYYY-MM-DD').toDate();
				},
				minDate: dateFrom.toDate(),
				maxDate: dateTo.toDate(),
				disableDayFn: function (date) {
					const isOutOfRange = moment(date).isBefore(dateFrom) || moment(date).isAfter(dateTo);
					const isWeekend = moment(date).day() === 0 || moment(date).day() === 6; // Sunday = 0, Saturday = 6
					return isOutOfRange || isWeekend;
				},
				i18n: {
					previousMonth: 'Ankstesnis mėnuo',
					nextMonth: 'Kitas mėnuo',
					months: moment.localeData().months(),
					weekdays: moment.localeData().weekdays(),
					weekdaysShort: moment.localeData().weekdaysShort()
				},
				yearRange: [1900, new Date().getFullYear()],
				position: 'right'
			});

			element.addClass('datepicker');
		}
	};
});

EwSiteApp.directive('datepicker1fromtodayonlyworkdays', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			new Pikaday({
				field: element[0],
				firstDay: 1,
				format: 'YYYY-MM-DD',
				showDaysInNextAndPreviousMonths: true,
				minDate: new Date(),
				toString(date) {
					return moment(date).format('YYYY-MM-DD');
				},
				parse(dateString) {
					return moment(dateString, 'YYYY-MM-DD').toDate();
				},
				disableDayFn: function (date) {
					const isWeekend = moment(date).day() === 0 || moment(date).day() === 6; // Sunday = 0, Saturday = 6
					return isWeekend;
				},
				i18n: {
					previousMonth: 'Ankstesnis mėnuo',
					nextMonth: 'Kitas mėnuo',
					months: moment.localeData().months(),
					weekdays: moment.localeData().weekdays(),
					weekdaysShort: moment.localeData().weekdaysShort()
				},
				yearRange: [1900, new Date().getFullYear()],
				position: 'right'
			});
			element.addClass('datepicker');
		}
	};
});

EwSiteApp.directive('datepickerMaxOct2021', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
			const limitDate = new Date(2021, 9, 30);
            new Pikaday({
                field: element[0],
                firstDay: 1,
                format: 'YYYY-MM-DD',
                showDaysInNextAndPreviousMonths: true,
                // Set the hard limit to October 31, 2021
                maxDate: new Date(2021, 9, 30), // Note: Months are 0-indexed (9 = October)
				setDefaultDate: false,
                defaultDate: limitDate,
                toString(date) {
                    return moment(date).format('YYYY-MM-DD');
                },
                parse(dateString) {
                    return moment(dateString, 'YYYY-MM-DD').toDate();
                },
                i18n: {
                    previousMonth: 'Ankstesnis mėnuo',
                    nextMonth: 'Kitas mėnuo',
                    months: moment.localeData().months(),
                    weekdays: moment.localeData().weekdays(),
                    weekdaysShort: moment.localeData().weekdaysShort()
                },
                yearRange: [1990, 2021],
                position: 'right'
            });
            element.addClass('datepicker');
        }
    };
});

EwSiteApp.directive('datepicker1totodayonlyworkdays', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			new Pikaday({
				field: element[0],
				firstDay: 1,
				format: 'YYYY-MM-DD',
				showDaysInNextAndPreviousMonths: true,
				maxDate: new Date(),
				toString(date) {
					return moment(date).format('YYYY-MM-DD');
				},
				parse(dateString) {
					return moment(dateString, 'YYYY-MM-DD').toDate();
				},
				disableDayFn: function (date) {
					const isWeekend = moment(date).day() === 0 || moment(date).day() === 6; // Sunday = 0, Saturday = 6
					return isWeekend;
				},
				i18n: {
					previousMonth: 'Ankstesnis mėnuo',
					nextMonth: 'Kitas mėnuo',
					months: moment.localeData().months(),
					weekdays: moment.localeData().weekdays(),
					weekdaysShort: moment.localeData().weekdaysShort()
				},
				yearRange: [1900, new Date().getFullYear()],
				position: 'right'
			});
			element.addClass('datepicker');
		}
	};
});

EwSiteApp.directive('datepicker1MaxDate', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			new Pikaday({
				field: element[0], // Ensure the raw DOM element is passed
				firstDay: 1,
				format: 'YYYY-MM-DD',
				showDaysInNextAndPreviousMonths: true,
				toString(date) {
					return moment(date).format('YYYY-MM-DD');
				},
				parse(dateString) {
					return moment(dateString, 'YYYY-MM-DD').toDate();
				},
				i18n: {
					previousMonth: 'Ankstesnis mėnuo',
					nextMonth: 'Kitas mėnuo',
					months: moment.localeData().months(),
					weekdays: moment.localeData().weekdays(),
					weekdaysShort: moment.localeData().weekdaysShort()
				},
				yearRange: [1900, new Date().getFullYear()], // Show years from 1900 to the current year
				position: 'right',
				maxDate: new Date() // Set the max date to today
			});
			element.addClass('datepicker'); // Use element directly without jQuery
		}
	};
});

EwSiteApp.directive('datepickerarivaldate', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {

			function addBusinessDays(date, days) {
				let result = new Date(date);
				let added = 0;
				while (added < days) {
					result.setDate(result.getDate() + 1);
					let day = result.getDay();
					if (day !== 0 && day !== 6) { // skippinam savaitgalius
						added++;
					}
				}
				return result;
			}

			let today = new Date();
			let minDate = addBusinessDays(today, 3); // pridedam +3 darbo dienas
			let maxDate = addBusinessDays(today, 10);

			function createDatepicker() {
				if (element[0].pikaday) {
					element[0].pikaday.destroy();
				}

				element[0].pikaday = new Pikaday({
					field: element[0],
					firstDay: 1,
					format: 'YYYY-MM-DD',
					setDefaultDate: true,
					showDaysInNextAndPreviousMonths: true,
					minDate: minDate,
					maxDate: maxDate,
					disableDayFn: function (date) {
						const day = date.getDay();
						return day === 0 || day === 6; // atjungiam savaitgalius
					},
					i18n: {
						previousMonth: 'Praėjęs mėnesis',
						nextMonth: 'Sekantis mėnesis',
						months: ['Sausis', 'Vasaris', 'Kovas', 'Balandis', 'Gegužė', 'Birželis', 'Liepa', 'Rugpjūtis', 'Rugsėjis', 'Spalis', 'Lapkritis', 'Gruodis'],
						weekdays: ['Sekmadienis', 'Pirmadienis', 'Antradienis', 'Trečiadienis', 'Ketvirtadienis', 'Penktadienis', 'Šeštadienis'],
						weekdaysShort: ['S', 'P', 'A', 'T', 'K', 'P', 'Š']
					}
				});
			}

			scope.$watch('excavation_end', function (excavation_end) {
				if (excavation_end) {
					let excDate = new Date(excavation_end * 1000);
					if(excDate > minDate && excDate < maxDate){
						maxDate = excDate;
						createDatepicker();
					}
				}
			});

			createDatepicker();
			element.addClass('datepicker');
		}
	};
});


EwSiteApp.directive('datepickerarivaldate2', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {

			function addBusinessDays(date, days) {
				let result = new Date(date);
				let added = 0;
				while (added < days) {
					result.setDate(result.getDate() + 1);
					let day = result.getDay();
					if (day !== 0 && day !== 6) { // skippinam savaitgalius
						added++;
					}
				}
				return result;
			}

			let today = new Date();
			let minDate = addBusinessDays(today, 3); // pridedam +3 darbo dienas

			if (element[0].pikaday) {
				element[0].pikaday.destroy();
			}

			element[0].pikaday = new Pikaday({
				field: element[0],
				firstDay: 1,
				format: 'YYYY-MM-DD',
				setDefaultDate: true,
				showDaysInNextAndPreviousMonths: true,
				minDate: minDate,
				disableDayFn: function (date) {
					const day = date.getDay();
					return day === 0 || day === 6; // atjungiam savaitgalius
				},
				i18n: {
					previousMonth: 'Praėjęs mėnesis',
					nextMonth: 'Sekantis mėnuo',
					months: ['Sausis', 'Vasaris', 'Kovas', 'Balandis', 'Gegužė', 'Birželis', 'Liepa', 'Rugpjūtis', 'Rugsėjis', 'Spalis', 'Lapkritis', 'Gruodis'],
					weekdays: ['Sekmadienis', 'Pirmadienis', 'Antradienis', 'Trečiadienis', 'Ketvirtadienis', 'Penktadienis', 'Šeštadienis'],
					weekdaysShort: ['S', 'P', 'A', 'T', 'K', 'P', 'Š']
				}
			});

			element.addClass('datepicker');
		}
	};
});



EwSiteApp.directive('datepickerMinInsurance', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			var picker = new Pikaday({
				field: element[0],
				firstDay: 1,
				format: 'YYYY-MM-DD',
				showDaysInNextAndPreviousMonths: true,
				minDate: new Date(),
				i18n: {
					previousMonth: 'Praėjęs mėnesis',
					nextMonth: 'Sekantis mėnesis',
					months: ['Sausis', 'Vasaris', 'Kovas', 'Balandis', 'Gegužė', 'Birželis', 'Liepa', 'Rugpjūtis', 'Rugsėjis', 'Spalis', 'Lapkritis', 'Gruodis'],
					weekdays: ['Sekmadienis', 'Pirmadienis', 'Antradienis', 'Trečiadienis', 'Ketvirtadienis', 'Penktadienis', 'Šeštadienis'],
					weekdaysShort: ['S', 'P', 'A', 'T', 'K', 'P', 'Š']
				},
				onSelect: function () {
					// Update scope variable for max date in the max insurance directive
					scope.$apply(function () {
					});
				}
			});
			element.addClass('datepicker_min_insurance');
		}
	};
});

EwSiteApp.directive('datepickerMaxInsurance', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			var picker = new Pikaday({
				field: element[0],
				firstDay: 1,
				format: 'YYYY-MM-DD',
				showDaysInNextAndPreviousMonths: true,
				maxDate: new Date(),
				i18n: {
					previousMonth: 'Praėjęs mėnesis',
					nextMonth: 'Sekantis mėnesis',
					months: ['Sausis', 'Vasaris', 'Kovas', 'Balandis', 'Gegužė', 'Birželis', 'Liepa', 'Rugpjūtis', 'Rugsėjis', 'Spalis', 'Lapkritis', 'Gruodis'],
					weekdays: ['Sekmadienis', 'Pirmadienis', 'Antradienis', 'Trečiadienis', 'Ketvirtadienis', 'Penktadienis', 'Šeštadienis'],
					weekdaysShort: ['S', 'P', 'A', 'T', 'K', 'P', 'Š']
				},
				onSelect: function () {
					// Update scope variable for min date in the min insurance directive
					scope.$apply(function () {
					});
				}
			});

			element.addClass('datepicker_max_insurance');

			// Watch for changes to the min date from the other directive
			scope.$watch('minInsuranceDate', function (newDate) {
				picker.setMinDate(newDate);
			});
		}
	};
});

EwSiteApp.directive('floatNumbersNegative', function () {
	return {
		restrict: 'A',
		scope: {
			value: '=ngModel'
		},
		controller: ['$scope', function ($scope) {
				$scope.$watch(function () {
					return $scope.value;
				}, function (newVal) {
					if (typeof newVal !== 'undefined') {
						newVal = newVal.replace(/,/, '.');
						newVal = newVal.replace(/[^0-9.\-]/g, '');
						if (newVal.includes('-')) {
							newVal = newVal.replace(/-/g, '');
							newVal = '-' + newVal;
						}
						const parts = newVal.split('.');
						if (parts.length > 2) {
							newVal = parts[0] + '.' + parts.slice(1).join('');
						}

						$scope.value = newVal;
					}
				});
			}]
	};
});

EwSiteApp.directive('floatNumbersLimit', function () {
	return {
		restrict: 'A',
		scope: {
			value: '=ngModel'
		},
		controller: ['$scope', function ($scope) {
				$scope.$watch(function () {
					return $scope.value;
				}, function (newVal) {
					if (typeof newVal !== 'undefined') {
						newVal = newVal.replace(/,/, '.');
						newVal = newVal.replace(/[^0-9.]/g, '');
						const parts = newVal.split('.');
						if (parts.length > 2) {
							newVal = parts[0] + '.' + parts.slice(1).join('');
						}
						const decimalIndex = newVal.indexOf('.');
						if (decimalIndex !== -1) {
							let decimalPart = newVal.substr(decimalIndex + 1);
							if (decimalPart.length > 3) {
								decimalPart = decimalPart.substr(0, 3);
							}
							newVal = newVal.substr(0, decimalIndex + 1) + decimalPart;
						}

						$scope.value = newVal;
					}
				});
			}]
	};
});

// Like floatNumbersLimit, but allows a single leading minus so negative
// values can be entered (used for "nauja galia" fields, ESOEW4-1375 LGG mažinimas).
EwSiteApp.directive('floatNumbersLimitNegative', function () {
	return {
		restrict: 'A',
		scope: {
			value: '=ngModel'
		},
		controller: ['$scope', function ($scope) {
				$scope.$watch(function () {
					return $scope.value;
				}, function (newVal) {
					if (typeof newVal !== 'undefined') {
						newVal = newVal.replace(/,/, '.');
						var negative = newVal.charAt(0) === '-';
						newVal = newVal.replace(/[^0-9.]/g, '');
						const parts = newVal.split('.');
						if (parts.length > 2) {
							newVal = parts[0] + '.' + parts.slice(1).join('');
						}
						const decimalIndex = newVal.indexOf('.');
						if (decimalIndex !== -1) {
							let decimalPart = newVal.substr(decimalIndex + 1);
							if (decimalPart.length > 3) {
								decimalPart = decimalPart.substr(0, 3);
							}
							newVal = newVal.substr(0, decimalIndex + 1) + decimalPart;
						}
						if (negative) {
							newVal = '-' + newVal;
						}

						$scope.value = newVal;
					}
				});
			}]
	};
});

EwSiteApp.directive('onlyLettersInput', function () {
	return {
		require: 'ngModel',
		link: function (scope, element, attr, ngModelCtrl) {
			function fromUser(text) {
				var transformedInput = text.replace(/[^a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\u0430-\u044f ]/g, '');
				if (transformedInput !== text) {
					ngModelCtrl.$setViewValue(transformedInput);
					ngModelCtrl.$render();
				}
				return transformedInput;
			}
			ngModelCtrl.$parsers.push(fromUser);
		}
	};
});

EwSiteApp.directive('vertApplicationTermNrPattern', function () {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function (scope, element, attrs, ngModelCtrl) {
			let maskedInputController;

			const applyMask = (rawValue) => {
				const contractMask = rawValue.match(/^\d\d\-RA/i)
						? [/\d/, /\d/, '-', /R/, /A/, /\d/, /\d/, /\d/, /\d/, /\d/] // Mask for XX-RA12345
						: [/\d/, /\d/, '-', /[a-zA-Z0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/]; // Default mask

				// Initialize masked input with the selected mask
				maskedInputController = maskInput({
					inputElement: element[0],
					mask: contractMask,
					guide: false,
					showMask: false
				});
			};

			// Apply initial mask
			applyMask(element.val());

			// Update the mask dynamically as user types
			element.on('input', function () {
				const currentValue = element.val();

				// Remove existing mask and reapply with updated mask
				maskedInputController.destroy();
				applyMask(currentValue);

				// Update ngModel with unmasked value
				const unmaskedValue = currentValue.replace(/-/g, '');
				ngModelCtrl.$setViewValue(unmaskedValue);
				scope.$apply(); // Trigger Angular digest cycle
			});

			// Model -> View (Update input field when the ngModel changes)
			ngModelCtrl.$render = function () {
				const viewValue = ngModelCtrl.$viewValue || '';
				maskedInputController.textMaskInputElement.update(viewValue);
			};
		}
	};
});

EwSiteApp.directive('protectionZoneMask', function () {
	return {
		restrict: 'A',
		require: 'ngModel', // Require ngModel controller
		link: function (scope, element, attrs, ngModelCtrl) {
			var mask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

			// Initialize the masked input
			var maskedInputController = maskInput({
				inputElement: element[0],
				mask: mask,
				guide: false,
				showMask: false
			});

			// View -> Model (Update the ngModel when user types)
			element.on('input', function () {
				// Get the current input value
				var currentValue = element.val();

				// Extract only the numbers, removing the mask characters
				var unmaskedValue = currentValue.replace(/-/g, '');

				// Update the ngModel with the unmasked value
				ngModelCtrl.$setViewValue(unmaskedValue);
				scope.$apply(); // Trigger Angular digest cycle
			});

			// Model -> View (Update input field when the ngModel changes)
			ngModelCtrl.$render = function () {
				var viewValue = ngModelCtrl.$viewValue || '';
				maskedInputController.textMaskInputElement.update(viewValue);
			};
		}
	};
});

EwSiteApp.directive('phonePrefixSubmit', function () {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function (scope, element, attrs, ngModel) {
			// Function to add prefix on form submission only
			function addPrefixOnSubmit(value) {
				if (value && !value.startsWith('+370')) {
					return '+370' + value;
				}
				return value;
			}

			// Listen for form submission event
			element.closest('form').on('submit', function () {
				var prefixedValue = addPrefixOnSubmit(ngModel.$viewValue);
				ngModel.$setViewValue(prefixedValue);
			});
		}
	};
});

EwSiteApp.directive('embedIframeCalc', ["$sce", function ($sce) {
		return {
			restrict: 'E',
			scope: {
				tid: '=',
				objektonr: '='
			},
			replace: true,
			link: function (scope, element, attrs) {
				function updateSrc() {
					if (typeof (scope.tid) !== 'undefined' && !isNaN(scope.tid) && scope.tid !== '') {
						let url = lcc_params.embed_ranking_url.replace(/__TID__/, scope.tid);
						if (scope.objektonr) {
							url += '&code=' + encodeURIComponent(scope.objektonr);
						}
						scope.src = $sce.trustAsResourceUrl(url);
					} else {
						scope.src = '';
					}
//			console.log("Trusted URL:", $sce.getTrustedResourceUrl(scope.src));
					scope.showFrame = (scope.src !== '');

				}
				scope.$watchGroup(['tid', 'objektonr'], function (newValues, oldValues) {
					updateSrc();
				});

				updateSrc();
			},
			template: '<div><iframe style="width: 100%; height: 481px" ng-if="showFrame" src="{{src}}"></iframe></div>'
		};

	}]);

EwSiteApp.directive('lettersNumbersOnly', function () {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function (scope, element, attrs, ngModelCtrl) {
			element.on('input', function () {
				let val = element.val();
				console.log(val)
				if (typeof val !== 'undefined') {

					let cleaned = val.replace(/[^a-zA-Z0-9]/g, '');
					if (val !== cleaned) {
						element.val(cleaned);
						ngModelCtrl.$setViewValue(cleaned);
						ngModelCtrl.$render();
					}
				}
			});
		}
	};
});
